import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';
import { Paginate } from '../../../model/paginate';
import { ResponseData, ResponsePaging } from '../nest-responses';
import { ResponseGetTeammatesDto, ResponseGetTodayTaskDto } from '../gd-only/dto/home-feed.dto';

@Injectable()
export class HomeFeedProvider {

  private _service: string = 'attendance';
  private _model: string = 'homeFeed';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getSubordinate(formData: { skip: number, limit: number }): Observable<any> {
    const method: string = "GET";
    const model: string = this._model;
    const func: string = "getSubordinate";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType, null, null, false);
  }

  public getSupervisor(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getSupervisor';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, null, null, null, false);
  }

  public getCoWorkers(formData: { skip: number, limit: number }): Observable<any> {
    const method: string = "GET";
    const model: string = this._model;
    const func: string = "getCoWorkers";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType, null, null, false);
  }

  public getTeamMates(page: number, limit: number, isEnable: boolean = true) {
    const _method: string = 'GET';
    const _func: string = 'getTeamMates';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof isEnable !== 'undefined' && isEnable !== null) _urlParams.isEnable = isEnable;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request<ResponseData<ResponseGetTeammatesDto[]>>(_method, _url, _params, _urlParams, _body, null, 60000, null, false);
  }

  public getAllFavorite(formData: { skip: number, limit: number, isEnable: boolean }): Observable<any> {
    const method: string = "GET";
    const model: string = this._model;
    const func: string = "getAllFavorite";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, model, func, params, urlParams, this._service);
    return this.nestApiProvider.request(method, url, params, urlParams, body, contentType, null, null, false);
  }

  public addFavorite(favoriteId: string): Observable<any> {
    const _method: string = "POST";
    const _func: string = "addFavorite";
    const _params: any = {
      favoriteId,
    } || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public delete(favoriteId: string): Observable<any> {
    const _method: string = "DELETE";
    const _func: string = "delete";
    const _params: any = {
      favoriteId,
    } || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public searchFavorite(page: number, limit: number, fullname: string): Observable<Paginate<any>> {
    const _method: string = 'GET';
    const _func: string = 'searchFavorite';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof fullname !== 'undefined' && fullname !== null) _urlParams.fullname = fullname;


    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request<Paginate<any>>(_method, _url, _params, _urlParams, _body);
  }

  public getTodayTask(queryPage: number, limit: number): Observable<ResponsePaging<ResponseGetTodayTaskDto>> {
    const _method: string = 'GET';
    const _func: string = 'getTodayTask';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof queryPage !== 'undefined' && queryPage !== null) _urlParams.page = queryPage;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetTodayTaskDto>>(_method, _url, _params, _urlParams, _body, null, null, null, false);
  }

  public getTodayOwnTask(page: number, limit: number): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getTodayOwnTask';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, null, null, null, false);
  }

  public updateTask(taskcode: string, statustask: number, status: number): Observable<any> {
    const _method: string = 'PUT';
    const _func: string = 'updateTask';
    const _params: any = {
      taskcode,
      statustask,
      status
    };
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

  public getIdTask(taskcode: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getIdTask';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof taskcode !== 'undefined' && taskcode !== null) _urlParams.taskcode = taskcode;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/home-feed/home-feed.ts